// sections: minicart / main-cart
if (typeof CartTimer !== "function") {
  class CartTimer extends HTMLElement {
    constructor() {
      super();

      const self = this;
      let time = parseInt(this.dataset.time);

      let now,
        finalDate,
        timerInterval = false;

      if (localStorage.getItem("cartTimerEnd")) {
        now = localStorage.getItem("cartTimerActual");
        finalDate = localStorage.getItem("cartTimerEnd");
      } else {
        now = new Date().getTime();
        finalDate = new Date(now + time * 6e4).getTime();
        localStorage.setItem("cartTimerActual", now);
        localStorage.setItem("cartTimerEnd", finalDate);
      }

      const timer = () => {
        now = new Date().getTime();
        localStorage.setItem("cartTimerActual", now);
        let diff = finalDate - now;

        if (diff < 0) {
          self.innerHTML =
            "<span>" + Shopify.translation.timer_ended + "</span>";
          if (diff < -86400000)
            localStorage.removeItem("cartTimerInitial"),
              localStorage.removeItem("cartTimerEnd");
          if (timerInterval) clearInterval(x);
        } else {
          let minutes = Math.floor((diff % (1e3 * 60 * 60)) / (1e3 * 60));
          let seconds = Math.floor((diff % (1e3 * 60)) / 1e3);

          minutes <= 9 ? (minutes = `0${minutes}`) : minutes;
          seconds <= 9 ? (seconds = `0${seconds}`) : seconds;

          if (minutes > 0) var text = Shopify.translation.date.m;
          else var text = Shopify.translation.date.minute;

          self.querySelector(".dynamic").textContent =
            minutes + ":" + seconds + " " + text;
        }
      };

      timer();
      timerInterval = true;
      const x = setInterval(timer, 1000);
    }
  }

  customElements.define("cart-timer", CartTimer);
}

if (typeof Cart !== "function") {
  class Cart extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      var self = this;

      this.cartFooter = this.querySelector("[data-sticky-mobile]");

      if (
        this.classList.contains("cart") &&
        this.cartFooter &&
        this.cartFooter.getAttribute("data-sticky-mobile") == "true"
      ) {
        if (document.documentElement.clientWidth < 779) {
          self.setPosition();
        } else {
          self.unsetPosition();
        }

        window.on(
          "resize",
          theme.utils.debounce(300, function () {
            if (document.documentElement.clientWidth < 779) {
              self.setPosition();
            } else {
              self.unsetPosition();
            }
          }),
        );
      } else {
        self.unsetPosition();
      }

      if (this.getAttribute("data-keep-on-page") == "true") this.keepOnPage();
      if (this.querySelector("shipping-calculator")) this.shippingCalculator();

      this.initListeners();

      document.addEventListener("updateCart", function (e) {
        self.getCart();
      });
    }

    initListeners() {
      var self = this;
      window.AddCount = 0;

      this.querySelectorAll(".quantity__button").forEach((button) => {
        button.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.updateItem(this.href);
        });
      });

      this.querySelectorAll("input.quantity__input").forEach((input) => {
        input.addEventListener("change", function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.updateInputItem(this);
        });
      });

      this.querySelectorAll("select.cart__selector-variant").forEach(
        (select) => {
          select.addEventListener("change", function (e) {
            e.preventDefault();
            self.updateVariant(
              this.value,
              this.dataset.actual,
              this.dataset.quantity,
            );
          });
        },
      );
    }

    removeListeners() {
      document.removeEventListener("updateCart", function () {
        self.getCart();
      });

      this.querySelectorAll(".quantity__button").forEach((button) => {
        button.removeEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.updateItem(this.href);
        });
      });

      this.querySelectorAll("input.quantity__input").forEach((input) => {
        input.removeEventListener("change", function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.updateInputItem(this);
        });
      });

      this.querySelectorAll("select.cart__selector-variant").forEach(
        (select) => {
          select.removeEventListener("change", function (e) {
            e.preventDefault();
            self.updateVariant(
              this.value,
              this.dataset.actual,
              this.dataset.quantity,
            );
          });
        },
      );
    }

    updateItem(url) {
      this.innerHTML += Shopify.theme_settings.loader;
      this.classList.add("loading");

      window.ajaxURL(url).then(function () {
        document.dispatchEvent(new CustomEvent("updateCart"));
      });
    }

    updateInputItem(input) {
      this.innerHTML += Shopify.theme_settings.loader;
      this.classList.add("loading");

      if (document.querySelectorAll(".cart-bubble")) {
        document.querySelectorAll(".cart-bubble").forEach((bubble) => {
          bubble.innerHTML = Shopify.theme_settings.loader;
        });
      }

      window
        .ajaxURL(
          theme.routes.cart_change_url +
            "?quantity=" +
            input.value +
            "&id=" +
            input.dataset.lineId,
        )
        .then(function () {
          document.dispatchEvent(new CustomEvent("updateCart"));
        });
    }

    updateVariant(variantId, actual, quantity) {
      this.innerHTML += Shopify.theme_settings.loader;
      this.classList.add("loading");

      if (document.querySelectorAll(".cart-bubble")) {
        document.querySelectorAll(".cart-bubble").forEach((bubble) => {
          bubble.innerHTML = Shopify.theme_settings.loader;
        });
      }

      window
        .ajaxURL(
          theme.routes.cart_change_url +
            "?quantity=" +
            quantity +
            "&id=" +
            actual,
        )
        .then(function () {
          window
            .ajaxURL(theme.routes.cart_add_url + "?quantity=1&id=" + variantId)
            .then(function () {
              document.dispatchEvent(new CustomEvent("updateCart"));
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }

    getCart() {
      const self = this;

      window.ajaxURL(theme.routes.cart_url).then(function (data) {
        self.renderCart(data);
      });
    }

    renderCart(data) {
      const self = this;
      let response = new DOMParser().parseFromString(data, "text/html"),
        container,
        miniCart;

      if (
        self.classList.contains("minicart-container") &&
        !self.closest(".cart-section")
      ) {
        (container = ".minicart-container"), (miniCart = true);
      } else {
        (container = ".cart-section"), (miniCart = false);
      }

      if (document.querySelectorAll(".cart-bubble")) {
        document.querySelectorAll(".cart-bubble").forEach((bubble) => {
          if (response.querySelector(".cart-bubble").innerHTML > 0) {
            bubble.classList.remove("hide"),
              (bubble.innerHTML =
                response.querySelector(".cart-bubble").innerHTML);
          } else {
            bubble.classList.add("hide");
          }
        });
      }

      if (
        response.querySelector(container + " .cart__empty") &&
        !self.querySelector(".cart__empty")
      ) {
        self
          .querySelectorAll(
            ':not(.cart__heading):not(.cart__cross-sell):not(.cart__content)[id^="block',
          )
          .forEach((block) => {
            block.classList.add("hide");
          });

        if (localStorage.getItem("cartTimerInitial")) {
          localStorage.removeItem("cartTimerInitial"),
            localStorage.removeItem("cartTimerEnd");
        }

        if (miniCart) {
          self.querySelector(container + " .cart").innerHTML =
            response.querySelector(container + " .cart").innerHTML;
        } else {
          self.innerHTML = response.querySelector(
            container + " .cart",
          ).innerHTML;
        }
      } else {
        if (miniCart) {
          if (self.querySelector(".cart__empty")) {
            self.querySelector(container + " .minicart-blocks").innerHTML =
              response.querySelector(container + " .minicart-blocks").innerHTML;
          } else {
            self.querySelector(container + " .cart__content").innerHTML =
              response.querySelector(container + " .cart__content").innerHTML;
          }

          self.querySelector(container + " .minicart-footer").innerHTML =
            response.querySelector(container + " .minicart-footer").innerHTML;
        } else {
          if (self.querySelector(".cart__empty")) {
            self.querySelector(container + " .cart__wrapper").innerHTML =
              response.querySelector(container + " .cart__wrapper").innerHTML;
          } else {
            self.querySelector(container + " .cart__content").innerHTML =
              response.querySelector(container + " .cart__content").innerHTML;
            self.querySelector(
              container + " .cart__footer:not(.added)",
            ).innerHTML = response.querySelector(
              container + " .cart__footer:not(.added)",
            ).innerHTML;
          }
        }

        self
          .querySelectorAll(
            ':not(.cart__heading):not(.cart__cross-sell):not(.cart__content)[id^="block',
          )
          .forEach((block) => {
            block.classList.remove("hide");
          });
      }

      if (miniCart) {
        if (this.closest("mini-cart")) {
          this.closest("mini-cart").bindEvents();

          // Render miniCart
          if (
            document.querySelectorAll("mini-cart").length > 0 &&
            (Shopify.theme_settings.atc_action == "once" ||
              Shopify.theme_settings.atc_action == "always") &&
            window.location.path !== "/cart"
          ) {
            var miniCartContainer = document.querySelector(
              ".menu-icons mini-cart",
            );
            document.body.classList.remove("scroll_up");
            document.body.classList.remove("scroll_down");
            miniCartContainer.open();
          }
        }
      } else {
        if (self.querySelector("product-form")) {
          self.querySelectorAll("product-form").forEach((product) => {
            const form = product.querySelector("form");

            if (form) {
              form.addEventListener(
                "submit",
                product.onSubmitHandler.bind(product),
              );
            }
          });
        }
      }

      self.initListeners();

      self.querySelectorAll(".loader").forEach((loader) => loader.remove());
      self.classList.remove("loading");

      self.querySelectorAll("img", "svg").forEach((lazyBackground) => {
        theme.utils.lazyBackgroundObserver.observe(lazyBackground);
      });

      if (self.querySelector(".cart__shipping_calculator:not(.hide)")) {
        self.querySelector(
          ".cart__shipping_calculator:not(.hide) .cart__shipping-progress-bar",
        ).dataset.width = parseFloat(
          response.querySelector(container + " .cart__shipping-progress-bar")
            .dataset.width,
        );
        self.querySelector(
          ".cart__shipping_calculator:not(.hide) .cart__shipping-progress-bar",
        ).dataset.left = parseFloat(
          response.querySelector(container + " .cart__shipping-progress-bar")
            .dataset.left,
        );

        const shippingStyles = response.querySelectorAll(
          container + " .cart__shipping_calculator:not(.hide) style",
        );

        if (shippingStyles.length > 0) {
          shippingStyles.forEach((style) => {
            const styleDom = document.createElement("style");
            styleDom.innerHTML = style.innerHTML;
            self
              .querySelector(".cart__shipping-step-bar")
              .appendChild(styleDom);
          });
        }

        setTimeout(function () {
          self.shippingCalculator();
        }, 500);
      }

      document.dispatchEvent(new CustomEvent("cartRendered"));
    }

    setPosition() {
      if (this.cartFooter) {
        this.cartFooter.closest(".cart").classList.add("added");
        document.querySelector("footer").style.marginBottom =
          content.offsetHeight + "px";
      }
    }

    unsetPosition() {
      document.querySelector("footer").style.marginBottom = "";
      if (this.cartFooter) {
        this.cartFooter.closest(".cart").classList.remove("added");
      }
    }

    AddFreeProduct(productId, step) {
      const isUpdatingCart = localStorage.getItem("isUpdatingCart");

      // Ne pas continuer si le produit est déjà ajouté ou une mise à jour est en cours
      if (isUpdatingCart === "true") return;

      localStorage.setItem("isUpdatingCart", "true");

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(productId),
              quantity: 1,
            },
          ],
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          localStorage.setItem(`free_product_${step}`, data.items[0].id);
          localStorage.setItem("isUpdatingCart", "false");
          document.dispatchEvent(new CustomEvent("updateCart"));
        })
        .catch((error) => {
          console.error("Error adding product:", error);
          localStorage.setItem("isUpdatingCart", "false");
        });
    }

    RemoveFreeProduct(productId, step) {
      const isUpdatingCart = localStorage.getItem("isUpdatingCart");

      // Ne pas continuer si le produit n'est pas dans le panier ou une mise à jour est en cours
      if (isUpdatingCart === "true") return;

      localStorage.setItem("isUpdatingCart", "true");

      const cartItems = this.querySelectorAll(".cart__content .cart-item");
      let productIndexInCart = null;

      cartItems.forEach((item, index) => {
        if (item.dataset.productId === productId) {
          productIndexInCart = index;
        }
      });

      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: productId,
          quantity: 0,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          localStorage.removeItem(`free_product_${step}`);
          document.dispatchEvent(new CustomEvent("updateCart"));
          localStorage.setItem("isUpdatingCart", "false");

          this.getCart();
        })
        .catch((error) => {
          console.error("Error removing product:", error);
          localStorage.setItem("isUpdatingCart", "false");
        });
    }

    shippingCalculator(width, left) {
      if (this.parentElement.classList.contains("minicart-section")) {
        return;
      }

      const self = this;

      const shippingCalculator = this.querySelector("shipping-calculator");
      const bar = shippingCalculator.querySelector(
        ".cart__shipping-progress-bar",
      );
      const step = parseFloat(bar.dataset.step, 2);
      const totalWidth = parseFloat(bar.dataset.totalWidth, 2);
      const paidContent = shippingCalculator.querySelector(
        ".cart__shipping-title-paid",
      );
      const freeContent = shippingCalculator.querySelector(
        ".cart__shipping-title-free",
      );
      const stepsContainer = shippingCalculator.querySelectorAll(
        ".cart__shipping-progress-bar-container .cart__shipping-step-bar",
      );

      left = parseFloat(bar.dataset.left, 2);
      width = parseFloat(bar.dataset.width, 2);

      function updateStepsContainer() {
        let gift = "";

        stepsContainer.forEach((stepContainer, i) => {
          const stepWidth = (100 * (i + 1)) / (step + 1);
          stepContainer.style.left = `calc(${stepWidth}% - 16px)`;

          const productId = stepContainer.dataset.productId;
          const productAdded = localStorage.getItem(`free_product_${i}`);
          const isUpdatingCart =
            localStorage.getItem("isUpdatingCart") === "true";

          if (gift === "") {
            gift = stepsContainer[i].dataset.phrase;
          }

          if (width >= stepWidth) {
            // Mettez à jour le message de `gift` si le palier est atteint
            if (i === stepsContainer.length - 1) {
              // Si on est au dernier palier, définissez `gift` pour `freeContent`
              gift = "";
            } else {
              gift = stepsContainer[i + 1].dataset.phrase;
            }

            if (!isUpdatingCart && productId && !productAdded) {
              self.AddFreeProduct(productId, i);
            }

            stepContainer.classList.add("reached");
            stepContainer.dataset.reached = true;
          } else {
            if (
              width <= stepWidth &&
              !isUpdatingCart &&
              productId &&
              productAdded !== null
            ) {
              self.RemoveFreeProduct(productAdded, i);
            }

            stepContainer.dataset.reached = false;
            stepContainer.classList.remove("reached");
          }
        });

        if (gift !== "") {
          paidContent.querySelector(".gift").innerText = gift;
        } else {
          freeContent.querySelector(".gift").innerText =
            stepsContainer[stepsContainer.length - 1].dataset.phrase;
        }
      }

      function updatePaidContent() {
        paidContent.classList.remove("hide");
        freeContent.classList.add("hide");

        setTimeout(function () {
          paidContent.classList.remove("visibility-hidden");
          freeContent.classList.add("visibility-hidden");
        }, 100);

        const priceElement = paidContent.querySelector(
          ".cart__shipping-title-paid-price",
        );

        if (priceElement.querySelector("span.money")) {
          priceElement.querySelector("span.money").innerHTML =
            theme.Currency.formatMoney(left);
        } else if (priceElement.innerHTML.includes("price")) {
          priceElement.innerHTML = priceElement.textContent.replace(
            "price",
            `<b>${theme.Currency.formatMoney(left)}</b>`,
          );
        } else {
          priceElement.querySelector("b").innerHTML =
            `<b>${theme.Currency.formatMoney(left)}</b>`;
        }
      }

      function updateProgressBar() {
        const progressBarContainer = shippingCalculator.querySelector(
          ".cart__shipping-progress-bar-container",
        );

        progressBarContainer.classList.remove("hide");

        setTimeout(function () {
          bar.style.width = "calc(" + width + "% - 16px)";
        }, 500);
      }

      function updateFreeContent() {
        freeContent.classList.remove("hide");
        paidContent.classList.add("hide");
        shippingCalculator
          .querySelector(".cart__shipping-progress-bar-container")
          .classList.add("hide");

        setTimeout(function () {
          freeContent.classList.remove("visibility-hidden");
          paidContent.classList.add("visibility-hidden");
        }, 100);
      }

      if (stepsContainer.length > 0) {
        updateStepsContainer();

        if (left > 0 && width < totalWidth) {
          updatePaidContent();
          updateProgressBar();
        } else {
          updateFreeContent();
        }
      }
    }

    keepOnPage() {
      var pageTitle = document.title;
      var attentionMessage = Shopify.translation.keep_on_page;

      document.addEventListener("visibilitychange", function (e) {
        var isPageActive = !document.hidden;

        if (!isPageActive) {
          setTimeout(function () {
            document.title = attentionMessage;
          }, 300);
        } else {
          document.title = pageTitle;
        }
      });
    }

    disconnectedCallback() {
      this.removeListeners();
    }
  }
  customElements.define("cart-js", Cart);
}
